import React from "react";
import ReactDOM from "react-dom";
import './SelectProductTooltip.scss'

const SelectProductTooltip = ( {ui} ) => {
  const selectProductTooltipText = ui.selectProductTooltipText;

  
  return ReactDOM.createPortal(
    <>
      {selectProductTooltipText}
    </>,
    document.getElementById("selectProductBox")
  );
};

export default SelectProductTooltip;
